import React, { useEffect, useState, useContext } from 'react';
import { Row, Select } from 'antd';
import { PrimaryButton } from '../../Commons';
import { StepContext, WorkflowContext } from '../../Commons/Context';
import StepContainer from '../../Components/StepContainer';

const bankTrtansactionStatuses = [
    { label: 'AUTHORISED', value: 'AUTHORISED' },
    { label: 'DELETED', value: 'DELETED' },
];

const ChooseBankTransactionStatus = () => {
	const { mappings, setActionData} = useContext(WorkflowContext);
	const { appName, next, id } = useContext(StepContext);
	const [transactionStatus, setTransactionStatus] = useState();
	const [transactionStatusValue, setTransactionStatusValue] = useState();
	const [preSelectedStatus, setPreSelectedStatus] = useState({});
	const [loading, setLoading] = useState(true);




	//2. When retrieved, fetch the old selected sobject if any
	useEffect(() => {
		if (bankTrtansactionStatuses.length > 0) getSalesForcTransaction();
	}, [bankTrtansactionStatuses]);

	const getSalesForcTransaction = async () => {
		mappings?.forEach((v) =>{
			if(v.type === 'CON' && v.field === 'Status'){
				bankTrtansactionStatuses?.forEach((m)=>{
					if(m.value === v.value){
						setTransactionStatus(m.value);
						setPreSelectedStatus({ type: v.type, field: v.field, value: v.value,  stepId: id, valueStepOrder: v.valueStepOrder })
					}
				})
			}
		})
	};

	const handleSelect = (statusValue) => {
		setTransactionStatusValue(statusValue);
		bankTrtansactionStatuses?.forEach((m)=>{
			if(m.value === statusValue){
				setTransactionStatus(m.value);
			}
		})
	};
	const handleMapping = ()=>{
		let MAPPINGS = [];
		MAPPINGS = transactionStatusValue 
		? [...MAPPINGS, { type: 'CON', field: "Status", value: transactionStatusValue,  stepId: id, valueStepOrder: 1 }]
		: [...MAPPINGS, preSelectedStatus];
		setActionData(MAPPINGS);
		next();
	}

	return (
		<StepContainer title='Choose BankTransaction Status'>
			<div>
				{`${appName} BankTransaction Status: `} <span className='required'>(required)</span>
			</div>

			<Row justify='center'>
				<Select
					className='fill-width rounded'
					//loading={loading}
					onSelect={handleSelect}
					placeholder='Select'
					showSearch
					value={transactionStatus}
					optionFilterProp='children'>
					{bankTrtansactionStatuses.map((v, k) => (
						<Select.Option value={v.value} key={k}>
							{v.label}
						</Select.Option>
					))}
				</Select>
			</Row>

			<Row justify='center'>
				<PrimaryButton
					className='btn-long'
					size='large'
					onClick={() => handleMapping()}>
					Continue
				</PrimaryButton>
			</Row>
		</StepContainer>
	);
};

export default ChooseBankTransactionStatus;